module.exports = "https://s91588.cdn.ngenix.net/home/_next/static/images/osago@2x-210f1273670398648f93c0743a4b57f6.png";